import { render, staticRenderFns } from "./pricing-plans.vue?vue&type=template&id=6dd40e08&scoped=true&"
import script from "./pricing-plans.vue?vue&type=script&lang=js&"
export * from "./pricing-plans.vue?vue&type=script&lang=js&"
import style0 from "./pricing-plans.vue?vue&type=style&index=0&id=6dd40e08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd40e08",
  null
  
)

export default component.exports